import type { PageGroupKey } from "../../shared/rbac";

/**
 * 로그인 후 첫 진입 페이지 후보 — 사이드바(AppSidebar.buildNavGroups) 노출 순서와 동일하게 둔다.
 * "그 계정이 실제로 들어갈 수 있는 첫 메뉴"를 이 순서로 훑어 결정한다.
 *
 * 과거엔 "/"가 무조건 /crm/customers로 고정 리다이렉트했는데, CRM 권한이 없는 계정은
 * RBACRoute(fallback="/")와 맞물려 무한 리다이렉트 루프에 빠졌다. 진입점은 고정값이 아니라
 * 권한에서 계산되는 값이어야 한다.
 */
const LANDING_ORDER: { group: PageGroupKey; path: string }[] = [
  { group: "crm", path: "/crm/customers" },
  { group: "policy", path: "/policy/pipeline" },
  { group: "inventory", path: "/inventory/devices" },
  { group: "kakao_counsel", path: "/kakao-counsel" },
];

/**
 * 접근 가능한 첫 페이지 경로를 돌려준다. 어떤 그룹에도 권한이 없으면 null.
 * @param can AuthContext.can — 권한 로딩 중엔 true를 반환하므로, 로딩 중엔 항상 첫 후보(CRM)를 준다.
 */
export function firstAccessiblePath(
  can: (group: PageGroupKey) => boolean,
): string | null {
  for (const { group, path } of LANDING_ORDER) {
    if (can(group)) return path;
  }
  return null;
}
